import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallProduktinstruktionBaseCommand } from "./ProduktionsmallProduktinstruktionBaseCommand";

export class UpdateProduktionsmallProduktinstruktionCommand extends ProduktionsmallProduktinstruktionBaseCommand {
    medIUtbytessimulering: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateProduktionsmallProduktinstruktionCommand";

    constructor(produktionsmallGuid: string, handelssortimentId: number, produktId: number, produktinstruktionId: number) {
        super(UpdateProduktionsmallProduktinstruktionCommand.$type, CommandType.Replace);
        this.produktionsmallGuid = produktionsmallGuid;
        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.produktinstruktionId = produktinstruktionId;
    }
}
